import { render } from "./CreateEditEnrichmentModal.vue?vue&type=template&id=929e6a28&scoped=true"
import script from "./CreateEditEnrichmentModal.vue?vue&type=script&lang=js"
export * from "./CreateEditEnrichmentModal.vue?vue&type=script&lang=js"

import "./CreateEditEnrichmentModal.vue?vue&type=style&index=0&id=929e6a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-929e6a28"]])

export default __exports__